'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _doctifyStarRating = require('./doctify-star-rating');

var _doctifyStarRating2 = _interopRequireDefault(_doctifyStarRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxStars = 5;

var DoctifyFiveStarRating = function DoctifyFiveStarRating(props) {
	return _react2.default.createElement(_doctifyStarRating2.default, { rating: props.rating, maxStars: maxStars });
};

DoctifyFiveStarRating.propTypes = {
	rating: require('react').PropTypes.number.isRequired
};
DoctifyFiveStarRating.defaultProps = { rating: 0 };

exports.default = DoctifyFiveStarRating;